import React from "react";
import PropTypes from "prop-types";
import { Card, Col } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import "./styles/card-element.css"

const cardStyle = { borderRadius: "20px" };

const CardElement = (props) => {
  const { title, subHeading, showClose, onClose, children } = props;
  return (
    <div className="containerTitleStyles">
      <div className="container_ab">
        <div className="container_style_2">
          {title && (
            <div className="title-row">
              <h2 className="title">{title}</h2>
              {subHeading && <h3 className="sub-heading">{subHeading}</h3>}
            </div>
          )}
          <Card style={cardStyle}>
            {showClose && (
              <Col
                span={24}
                style={{
                  marginRight: "0",
                  display: "flex",
                  justifyContent: "flex-end",
                  color: "#3B6CB4",
                }}
              >
                <CloseOutlined onClick={onClose} />
              </Col>
            )}
            {children}
          </Card>
        </div>
      </div>
    </div>
  );
};

CardElement.defaultProps = {
  title: "",
  subHeading: undefined,
  showClose: false,
  children: null,
  onClose: () => {},
};

CardElement.propTypes = {
  title: PropTypes.string,
  subHeading: PropTypes.string,
  showClose: PropTypes.bool,
  children: PropTypes.node,
  onClose: PropTypes.func,
};

export default CardElement;
